import { type FC } from "react";
import Modal from "~/common/components/Modal";
import ResetPasswordForm from "~/features/auth/login/components/ResetPasswordForm";
import PageTitle from "~/common/components/PageTitle/v1/PageTitle";
import { useResetPasswordLogic } from "~/features/auth/login/hooks/useResetPasswordLogic";
import { useTranslation } from "react-i18next";
import { Button } from "~/common/mui";

interface ExpiredPasswordChangePageViewProps {
  isResetPopupOpen: boolean;
  onOpenResetPopup: () => void;
  onCloseResetPopup: () => void;
  onResetSuccess: (globalErrors: string[]) => void;
}

export const ExpiredPasswordChangePageView: FC<ExpiredPasswordChangePageViewProps> = ({
  isResetPopupOpen,
  onOpenResetPopup,
  onCloseResetPopup,
  onResetSuccess,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <PageTitle title={t("forgottenPwd.expired.title")} />

      <p className={"mb-30"}>{t("forgottenPwd.expired.subtext")} </p>

      <Button onClick={onOpenResetPopup} data-test-id={"reset-pw-btn"}>
        {t("forgottenPwd.expired.buttontext")}
      </Button>

      {isResetPopupOpen && (
        <Modal onClose={onCloseResetPopup} title={t("popup.forgottenPassword.title")}>
          <ResetPasswordForm onSuccess={onResetSuccess} />
        </Modal>
      )}
    </>
  );
};

const ExpiredPasswordChangePage: FC = () => {
  const { isResetPopupOpen, openResetPopup, closeResetPopup, onResetSuccess } = useResetPasswordLogic();

  return (
    <ExpiredPasswordChangePageView
      isResetPopupOpen={isResetPopupOpen}
      onOpenResetPopup={openResetPopup}
      onCloseResetPopup={closeResetPopup}
      onResetSuccess={onResetSuccess}
    />
  );
};

export function createExpiredPasswordChangePage() {
  return <ExpiredPasswordChangePage />;
}
